import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import ViewGrid from 'mdi-react/ViewGridIcon';
import ViewList from 'mdi-react/ViewListIcon';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

function translate(transFunc, domain, field, data) {
  return transFunc ? transFunc(domain, field, data) : field;
}

const LayoutPicker = ({ mode, onClick }) => {
  const { t } = useContext(AppContext);
  return (
    <S.LayoutPicker>
      <S.Button
        onClick={() => onClick(mode === 'grid' ? 'row' : 'grid')}
        aria-label={translate(t, 'symbols', 'symbol.card-layout')}
      >
        {mode === 'row' ? <ViewGrid size={24} /> : <ViewList size={24} />}
      </S.Button>
    </S.LayoutPicker>
  );
};

LayoutPicker.propTypes = {
  mode: PropTypes.oneOf(['row', 'grid']),
  onClick: PropTypes.func,
};

LayoutPicker.defaultProps = {
  mode: 'row',
  onClick: () => {},
};

export default memo(LayoutPicker);
